import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TrinityService } from '../services/trinity.service';
import * as XLSX from 'xlsx';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-trinity-widget',
  templateUrl: './trinity-widget.component.html',
  styleUrls: ['./trinity-widget.component.scss']
})
export class TrinityWidgetComponent implements OnInit {
  public isSamplingCostEditing:boolean = false;
  public isProfessionalCostEditing:boolean = false;
  // public note: string[] = [];
  @ViewChild('scrollableDiv') scrollableDiv: ElementRef | undefined;
  constructor(
    public trinityService:TrinityService,
    public notifier:NotifierService
  ) { 
    // this.note = [
    //   "These costs include everything: PM support, Ops, DP and scripting.",
    //   "Logistics and courier cost will be on actuals (ApproxINR150 per respondent)",
    //   "We will need 13-14 days for recruitment even if the product is received earlier",
    //   "Recall surveys will be Via self administered surveys."
    // ]
  }

  ngOnInit(): void {
    // this.trinityService.getTrinityWidgetData();
  }

  onSamplingCostEdit(){
    this.isSamplingCostEditing = !this.isSamplingCostEditing;
  }

  onApplySamplingDiscount(){
    let body = {
      "uuid": this.trinityService.trinityUUid,
      "discount":this.trinityService.trinityWidgetData['sampling_cost_discount']['selectedValue'],
      "discount_for":"sampling_cost"
    }
    this.trinityService.applyDiscount(body).subscribe((res:any) =>{
      if(res.status == 1){
        this.notifier.notify('success','Discount applied successfully');
        this.getQuoteDetails();
      }else{
        this.notifier.notify('error',res.message);
      }
    });
    this.isSamplingCostEditing = false;
  }

  onProfessionalCostEdit(){
    this.isProfessionalCostEditing = !this.isProfessionalCostEditing;
    this.scrollToBottom();
  }

  onApplyProfessionalDiscount(){
    let body = {
      "uuid": this.trinityService.trinityUUid,
      "discount":this.trinityService.trinityWidgetData['professional_time_cost_discount']['selectedValue'],
      "discount_for":"professional_time_cost"
    }
    this.trinityService.applyDiscount(body).subscribe((res:any) =>{
      if(res.status == 1){
        this.notifier.notify('success','Discount applied successfully');
        this.getQuoteDetails();
      }else{
        this.notifier.notify('error',res.message);

      }
    });
    this.isProfessionalCostEditing = false;
  }

  getQuoteDetails() {
    this.trinityService.getQuoteDetails(this.trinityService.trinityUUid).subscribe((result) => {
      if (result["status"] == 1) {
        let data = result['data'];
        this.trinityService.tid = result["tid"];
        this.trinityService.trinityWidgetData = result.cost_misc	|| {};
        // this.trinityService.trinityWidgetData['sampling_cost_discount'] = {"values":[5,10,15,20],"name":"Discount","action":{"type":"button","name":"Apply"},"selectedValue":5,"hideKey":"Discount"}
        // this.trinityService.trinityWidgetData['professional_time_cost_discount'] = {"values":[5,10,15,20],"name":"Discount","action":{"type":"button","name":"Apply"},"selectedValue":5}
      }else{
        this.notifier.notify('error','Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })

  }

  downloadExcel(): void {
    this.trinityService.getDownloadUrl().subscribe((res:any) => {
      if (res["status"] == 1) {
        this.onDownload(res["url"]);
      }else{
        this.notifier.notify('error', "Some thing went wrong !");
      }
    }, (error) => {
    });
  }

  onDownload(url){
    let ahref:HTMLElement = document.getElementById('downloadFileURL');
    const data = url;
    ahref.setAttribute("href", url);
    ahref.setAttribute("target", "_blank");
    ahref.setAttribute(
      "download",
      "trinity_data.xlsx"
    );
    ahref.click();
  }

  // openOutlook() {
  //   const email = 'shaina.arya@ipsos.com'; // Replace with the actual PM email address
  //   // const subject = `Request for Quote on Study ${this.trinityService.trinityQuoteSaveId}`;
  //   const subject = `Request for Quote on Study ${this.trinityService.trinityQuoteSaveName}`;
  //   const body = `Hi Team,\n\n I hope this message finds you well. I am reaching out to request a quote for a study that is not automatically feasible through the Trinity panel. Please find the study details attached to this email.\n\nThank you for your assistance.\n\n Regards, \n[Your Name]`; // Add the study details here
  //   const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  //   window.location.href = mailtoLink;
  // }

  openOutlook() {
    const email = 'shaina.arya@ipsos.com'; // Replace with the actual PM email address
    // const subject = `Request for Quote on Study ${this.trinityService.trinityQuoteSaveId}`;
    const subject = `Request for Quote on Study ${this.trinityService.trinityQuoteSaveName}`;
    const body = `Hi Team,\n\n I hope this message finds you well. I am reaching out to request a quote for a study that is not automatically feasible through the Trinity panel. Please find below the request id for your reference. \n\n Request Id - ${this.trinityService.trinityQuoteRequestId} \n\nThank you for your assistance.\n\n Regards, \n[Your Name]`; // Add the study details here
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  }


  scrollToBottom(): void {
    setTimeout(() => {
      const div = this.scrollableDiv.nativeElement;
      const scrollHeight = div.scrollHeight;
      const clientHeight = div.clientHeight;
      const scrollTop = scrollHeight - clientHeight;
    
      // Create smooth scrolling with requestAnimationFrame
      const currentScroll = div.scrollTop;
      const distanceToScroll = scrollTop - currentScroll;
      const duration = 300; // Duration of the scroll in milliseconds
      let startTime: number = null;
    
      function animateScroll(time: number) {
        if (!startTime) startTime = time;
        const timeElapsed = time - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        div.scrollTop = currentScroll + distanceToScroll * progress;
    
        if (timeElapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      }
    
      requestAnimationFrame(animateScroll);
    }, 0);
  }
 
  

}
